import React, { useRef } from 'react';
import { FormikValues } from 'formik';
import { Card } from '@material-ui/core';
import { AssignmentReturned as AssignmentReturnedIcon } from '@material-ui/icons';

import InlineForm from '../../../common/inline/InlineForm';
import InlineFormik from '../../../common/inline/InlineFormik';
import InlineTextField from '../../../common/inline/InlineTextField';
import CardContent from '../../../common/card/CardContent';
import CardTitle from '../../../common/card/CardTitle';

import { BaseScarCardProps, Scar } from '../Scar.interface';
import InlineDatePicker from '../../../common/inline/InlineDatePicker';
import { useTaskEntityFields } from '../../workflow/Workflow.hooks';
import { useUpdateScar } from '../Scar.hook';
import AppSnackbar from '../../../common/AppSnackbar';

const PreventiveActionCard: React.FC<BaseScarCardProps> = (
  props: BaseScarCardProps
) => {
  const formikRef = useRef<FormikValues>();
  const { scar, onChange } = props;
  const {
    containmentAction,
    containmentCompletedDate,
    permanentCorrectiveAction,
    premanentCorrectiveActionDate,
    correctiveActionVerification
  } = scar;
  const { isUpdating, updateError, updateScar } = useUpdateScar(scar.id);
  const { isFieldDisabled } = useTaskEntityFields(scar.task);

  return (
    <Card>
      <CardTitle>
        <AssignmentReturnedIcon />
        Containment and Preventive Action
      </CardTitle>
      <CardContent padding='large'>
        <InlineFormik
          innerRef={(formik: any) => (formikRef.current = formik)}
          isSubmitting={isUpdating}
          initialValues={{
            containmentAction: containmentAction || '',
            containmentCompletedDate: containmentCompletedDate || null,
            permanentCorrectiveAction: permanentCorrectiveAction || '',
            premanentCorrectiveActionDate:
              premanentCorrectiveActionDate || null,
            correctiveActionVerification: correctiveActionVerification || ''
          }}
          onSubmit={(
            scarDto: Omit<
              Partial<Scar>,
              'containmentCompletedDate' | 'premanentCorrectiveActionDate'
            > & {
              containmentCompletedDate: Date | null | undefined;
              premanentCorrectiveActionDate: Date | null | undefined;
            }
          ) => {
            console.log('update scar');
            updateScar(scarDto);
            onChange?.(scarDto as Partial<Scar>);
          }}
        >
          {({ values }) => (
            <InlineForm>
              <InlineTextField
                multiline
                name='containmentAction'
                label='Containment Action'
                disabled={isFieldDisabled('containmentAction')}
                value={values.containmentAction}
              />
              <InlineDatePicker
                name='containmentCompletedDate'
                label='Containment Completion Date'
                disabled={isFieldDisabled('containmentCompletedDate')}
              />
              <InlineTextField
                multiline
                name='permanentCorrectiveAction'
                label='Corrective/Preventive Action'
                disabled={isFieldDisabled('permanentCorrectiveAction')}
                value={values.permanentCorrectiveAction}
              />
              <InlineDatePicker
                name='premanentCorrectiveActionDate'
                label='Completion Date'
                disabled={isFieldDisabled('premanentCorrectiveActionDate')}
              />
              <InlineTextField
                multiline
                name='correctiveActionVerification'
                label='Verification of effectiveness'
                disabled={isFieldDisabled('correctiveActionVerification')}
                value={values.correctiveActionVerification}
              />
            </InlineForm>
          )}
        </InlineFormik>
      </CardContent>
      <AppSnackbar severity='error' open={Boolean(updateError)}>
        Error updating SCAR.
      </AppSnackbar>
    </Card>
  );
};

export default PreventiveActionCard;
